const PageLoader = ({ }) => {
    const loaderstyle = {
        display: "block",
        marginLeft: "auto",
        marginRight: "auto",
        marginTop: "auto",
        marginBottom: "auto",
    };
    return (
        <img src="/images/loader-06.svg" alt="" style={loaderstyle} />
    )
}

export default PageLoader
